import React, { useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { projectMenuItems } from "Constants/projectMenuItems";
import ProjectList from "./components/ProjectList";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import Factor from "../Factor/Factor";
import Contract from "../Contract/Contract";
import Construction from "../Construction/Construction";
import Benefit from "./Benefit/Benefit";
import BenefitInfo from "./Benefit/components/BenefitInfo";

const Projects = () => {
  const dispatch = useDispatch();
  let StypeU = read("StypeU");
  const { selectedProject, isLoggedIn } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    isLoggedIn: state.auth.isLoggedIn,
  }));
  const [menuItems, setMenuItems] = useState(null);

  useEffect(() => {
    let _menu = projectMenuItems.filter((item) => item.userAccess.includes(StypeU));
    _menu.map((item) => {
      if (item.menu_title === "construction") {
        const status = !!read("constructCutList") || !!read("constructGlass");
        item.authorize = status;
        item.active = status;
        return null;
      }
      if (item.menu_title === "contract") {
        const status = !!read("contractRules");
        item.authorize = status;
        item.active = status;
        return null;
      }
    });
    const tabBar = _menu.map((item) => {
      if (((!selectedProject || selectedProject === "undefined") &&
        (item.menu_title === "design" || item.menu_title === "invoices" || item.menu_title === "contract" || item.menu_title === "construction" || item.menu_title === "profit")) || !item.authorize) {
        return item;
      } else if(item.menu_title === "design" && read("isLockProject") && read("StypeU")=="2") {
        return item;
      } else {
        return item;
      }
    });
    setMenuItems(tabBar);
  },[selectedProject])

  return (
    <>
      {
        menuItems ? (
          <>
            <div>
              <Switch>
                <Redirect
                  exact
                  from="/dashboard/projects"
                  to="/dashboard/projects/list"
                />
                <Redirect
                  exact
                  from="/dashboard/projects/design"
                  to="/design"
                />
                <PrivateRoute
                  exact
                  path="/dashboard/projects/list"
                  component={ProjectList}
                  isLoggedIn={isLoggedIn}
                />
                <PrivateRoute
                  exact
                  path="/dashboard/projects/invoices"
                  component={Factor}
                  isLoggedIn={isLoggedIn}
                />
                <PrivateRoute
                  exact
                  path="/dashboard/projects/contract"
                  component={Contract}
                  isLoggedIn={isLoggedIn}
                />
                <PrivateRoute
                  exact
                  path="/dashboard/projects/construction"
                  component={Construction}
                  isLoggedIn={isLoggedIn}
                />
                <PrivateRoute
                  exact
                  path="/dashboard/projects/profit"
                  component={Benefit}
                  isLoggedIn={isLoggedIn}
                />
                <PrivateRoute
                  path="/dashboard/projects/profit/:id"
                  component={BenefitInfo}
                  isLoggedIn={isLoggedIn}
                />
              </Switch>
            </div>
          </>
        ): <ProjectList />
      }
    </>
  );
};

export default Projects;
